// config.js
const ENV = process.env.REACT_APP_ENV;

const config = {
  development: {
    BUDDYX_API_BASE_URL: process.env.REACT_APP_BUDDYX_API_BASE_URL,
    TRANSACTION_API_BASE_URL: process.env.REACT_APP_TRANSACTION_API_BASE_URL,
    TRANSACTION_SERVICE_ID: process.env.REACT_APP_TRANSACTION_SERVICE_ID,
    // AUTH_API_BASE_URL: process.env.REACT_APP_AUTH_API_BASE_URL,
    // API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    APP_ALLOWED_ROLES: process.env.REACT_APP_ALLOWED_ROLES
      ? process.env.REACT_APP_ALLOWED_ROLES.split(",").map((item) => item.trim())
      : [],
    WSO2_BASE_URL: process.env.REACT_APP_WSO2_BASE_URL,
  },
  prodction: {
    BUDDYX_API_BASE_URL: process.env.REACT_APP_QA_BUDDYX_API_BASE_URL,
    TRANSACTION_API_BASE_URL: process.env.REACT_APP_QA_TRANSACTION_API_BASE_URL,
    TRANSACTION_SERVICE_ID: process.env.REACT_APP_QA_TRANSACTION_SERVICE_ID,
    // AUTH_API_BASE_URL: process.env.REACT_APP_QA_AUTH_API_BASE_URL,
    // API_BASE_URL: process.env.REACT_APP_QA_API_BASE_URL,
    APP_ALLOWED_ROLES: process.env.REACT_APP_ALLOWED_ROLES
    ? process.env.REACT_APP_ALLOWED_ROLES.split(",").map((item) => item.trim())
      : [],
    WSO2_BASE_URL: process.env.REACT_APP_QA_WSO2_BASE_URL,
  },
};

const finalConfig = config[ENV] || config.development; // Fallback to development

export default finalConfig;
